@if (key | functionalErrorItem | async; as errorItem) {
  <wl-functional-error
    [errorItem]="errorItem"
    [automationId]="automationId"
    [analyticsImpressionName]="
      errorItem.fields?.ModalTitle?.value ?? automationId
    "
  ></wl-functional-error>
}
